var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "25px",
    viewBox: "0 0 22 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2B4ED437-F65F-4A22-941F-B362D5C1F687@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,22.352 C15.5395,22.352 19.148,18.6875 19.148,14.1491667 C19.148,9.61083332 15.5383334,6.00116664 11,6.00116664 C6.46166665,6.00116664 2.85199997,9.61083332 2.85199997,14.1491667 C2.85199997,18.6875 6.46166665,22.352 11,22.352 Z M19.2028334,7.64033331 C20.625,9.44516665 21.5,11.6875 21.5,14.148 C21.5,19.9451667 16.7971667,24.648 11,24.648 C5.20283331,24.648 0.499999956,19.9451667 0.499999956,14.148 C0.499999956,8.35083331 5.20283331,3.64799996 11,3.64799996 C13.4605,3.64799996 15.7576667,4.5778333 17.5625,5.99999997 L19.2028334,4.3048333 C19.8048334,4.79716663 20.3508334,5.3443333 20.8431667,5.94516664 L19.2028334,7.64033331 Z M9.852,15.352 L9.852,8.35199998 L12.1491667,8.35199998 L12.1491667,15.352 L9.852,15.352 Z M14.5,0.147999946 L14.5,2.49999996 L7.49999999,2.49999996 L7.49999999,0.147999946 L14.5,0.147999946 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: -3,
    y: -1,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-15.0%",
    width: "134.3%",
    height: "134.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-35.000000, -174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Generic/timer",
    transform: "translate(35.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/timer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C45322",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer1X);
export default __webpack_public_path__ + "static/media/timer@1x.7659a22435ea9c576beab92664a046dc.svg";
export { ForwardRef as ReactComponent };